export default {
    activity: 'Activity',
    user: 'User',
    access: 'Access',
    accessPointSite: 'Access point / Site',
    accessType: 'Access Type',
    types: 'Types',
    time: 'Time',
    accessStatus: 'Access Status',
    statuses: 'Statuses',
    unlock: 'Unlock',
    addNote: 'Add Note',
    note: 'note',
    recentActivity: 'Recent Activity',
    updateNote: 'Update note',
    timestamp: 'Timestamp',
    compare: 'Compare',
    registerCardForUser: 'Register Card for a user',
    showPassUsage: 'Show Pass Usage',
    resetFilters: 'Reset Filters',
    callDoor: 'Call Door',
    liveView: 'Live View',
    zoom: 'Zoom',
    cardNumber: 'Card Number',
    facilityCode: 'Facility Code',
    addFaceRecognitionImage: 'Assign image to a User for Face Recognition',
    assign: 'Assign',
    pinDetails: 'PIN Details',
    passName: 'Pin Name',
    motionDetectionPremiumTitle: 'Your property, always on record.',
    motionDetectionPremiumIntro:
        'Motion Detection automatically clips and stores footage every time activity is detected — so you always have a record, without lifting a finger.',
    motionDetectionPremiumWhatsIncluded: '',
    motionDetectionPremiumItem1: '300 clips/day · 15 sec each · 30-day retention',
    motionDetectionPremiumItem2: 'Custom schedules to capture the right windows',
    motionDetectionPremiumItem3: 'Cloud-stored and ready to review anytime',
    motionDetectionPremiumItem4: '',
    motionDetectionPremiumPricingLead: 'Early bird pricing:',
    motionDetectionPremiumPricing: '$30/month/intercom device',
    motionDetectionPremiumCtaDescription: 'Tap Enable and our team will send you an invoice to get your account activated.',
    motionDetectionRequestEnable: 'Enable',
    motionDetectionInvoiceRequestInProgress:
        "The feature request is already in progress. Our team will send the invoice shortly, and we'll enable the feature as soon as the payment is completed.",
    motionDetectionLiveBannerMessage:
        'Motion Detection is live! Capture and review 15-sec video clips automatically whenever activity is detected at your doors.',
    motionDetectionLiveBannerViewMore: 'View More',
    eventsTab: 'Access Events',
    motionAlertsTab: 'Motion alerts',
};
